import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import EmergencyFundCard from './EmergencyFundCard';
import SavingsTargetCard from './SavingsTargetCard';
import DebtFreeDateCard from './DebtFreeDateCard';
import { useBudget } from '../../context/BudgetContext';

export default function GoalsModule() {
  const { t } = useTranslation();
  const { state } = useBudget();

  const showDebtCard = state.goals.hasDebt && state.debts.length > 0;

  return (
    <Box>
      <Typography variant="h6" fontWeight={600} sx={{ mb: 1.5, color: '#1E3A5F' }}>
        {t('budgetPlanner.goals.moduleTitle', 'Tus metas')}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={showDebtCard ? 4 : 6}>
          <EmergencyFundCard />
        </Grid>
        <Grid item xs={12} md={showDebtCard ? 4 : 6}>
          <SavingsTargetCard />
        </Grid>
        {showDebtCard && (
          <Grid item xs={12} md={4}>
            <DebtFreeDateCard />
          </Grid>
        )}
      </Grid>
    </Box>
  );
}
